export function Logo({ size = 22 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Ventrin"
      role="img"
    >
      {/* Ventrin mark: intelligent, premium, controlled gate and signal */}
      <path d="M9 4H21V20H9V16H17V8H9V4ZM3 10H9V14H3V10ZM11 10H15V14H11V10Z" fill="currentColor" />
    </svg>
  );
}
